import { render } from "./Collapse.vue?vue&type=template&id=53d9a510"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=53d9a510&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__